export default __webpack_public_path__ + "static/media/nutrition-journey.3e4df152.png";